import { useLocation } from "react-router-dom";
import Wrapper from "../../Components/Wrapper/wrapper";
import { StudentNavigationHeader } from "../../Constants/Enums/navigationHeader.enum";
import { Pageheader } from "../../Constants/pageheader";
import { StudentInfo } from "../../Components/student/StudentInfo";
import { useGetStudent } from "../../hooks/students/useGetStudent.hooks";
import { StudentParentInfo } from "../../Components/student/StudentParentInfo";
import { StudentGuardianInfo } from "../../Components/student/StudentGuardianInfo";
import { StudentSchoolFees } from "./StudentSchoolFees";

export const StudentDetailPage = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const section = searchParams.get("section");
  const studentId = searchParams.get("studentId") || "";

  const parsedStudentId = parseInt(studentId, 10);
  const { isLoading: isStudentLoading, data: student } = useGetStudent({
    studentId: parsedStudentId,
  });

  if (isStudentLoading) return <></>;
  if (!student) return <>No student found.</>;

  const {
    mother_info: motherInfo,
    father_info: fatherInfo,
    guardian_info: guardianInfo,
    ...studentInfo
  } = student;

  return (
    <Wrapper
      header={Pageheader.StudentDetails}
      headerNavigation={[
        {
          text: "Student info",
          section: StudentNavigationHeader.STUDENT_INFO,
        },
        {
          text: "Parent info",
          section: StudentNavigationHeader.PARENT_INFO,
        },
        {
          text: "Guardian info",
          section: StudentNavigationHeader.GUARDIAN_INFO,
        },
        {
          text: "School fees",
          section: StudentNavigationHeader.STUDENT_SCHOOL_FEES,
        },
      ]}
    >
      {section === StudentNavigationHeader.STUDENT_INFO ? (
        <StudentInfo studentInfo={studentInfo} studentId={student.id} />
      ) : (
        <></>
      )}

      {section === StudentNavigationHeader.PARENT_INFO ? (
        <StudentParentInfo
          motherInfo={motherInfo}
          fatherInfo={fatherInfo}
          studentId={student.id}
        />
      ) : (
        <></>
      )}

      {section === StudentNavigationHeader.GUARDIAN_INFO ? (
        <StudentGuardianInfo
          guardianInfo={guardianInfo}
          studentId={student.id}
        />
      ) : (
        <></>
      )}

      {section === StudentNavigationHeader.STUDENT_SCHOOL_FEES ? (
        <StudentSchoolFees studentId={student.id} />
      ) : (
        <></>
      )}
    </Wrapper>
  );
};
